/*
 * Version of Statement specific to customer project
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid } from '@mui/material';
import { TablePagination, Typography, Table,  TableBody, TableCell, TableRow, Tooltip  } from '@mui/material';
import { format } from 'date-fns';
import GetApp from '@mui/icons-material/GetApp';
import HelpOutline from '@mui/icons-material/HelpOutline';

import LoadingSpinner from '../ui/LoadingSpinner';
import SavingSpinner from '../ui/SavingSpinner';
import ServerError from '../ui/ServerError';
import AppBindStyles from '../../AppBindStyles';

import CustomerProjectStatementLines from './CustomerProjectStatementLines';
import CustomerProjectStatementLinesFetch from './CustomerProjectStatementLinesFetch';
import ProjectSelect from '../account/ProjectSelect';
import StatementSelect from '../account/StatementSelect';
import StatementSelectFetch from '../account/StatementSelectFetch';
import RefundAndTerminateDialog from './RefundAndTerminateDialog';
import AccountFetch from '../account/AccountFetch';

const abEnvironment = new AbEnvironment();
const CustomerProjectStatementQuery = graphql`
query CustomerProjectStatementQuery($cAccountId: UUID!, $projectId: UUID!, $startDate: Datetime, $endDate: Datetime, $first: Int, $offset: Int) {
  getcustomerstatementlinesforproject(caccountid: $cAccountId, projectid: $projectId, startts: $startDate, endts: $endDate, first: $first, offset: $offset) {
    totalCount
    nodes {
      beginningBalance
      paymentIn
      receivedIn
      chargeOut
      payoutOut
      endingBalance
      transactionId
      transactionTime
      transactionType
      accountId
      accountName
      psType
      psCcBrand
      psCcLast4
      psAchAccountNum
      psInAmt
      psOutAmt
      psCFee
      psRFee
      paymentStatus
      paymentStatusReason
      bcId
      bcLast4
      customerAppId
      appId
      appName
      appLogo
      bindCardCharge
      markup
      appbindFee
      passThroughFee
      balance
      paidByBalance
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      //marginTop: 10,
    },
    flex: {
      flex: 1,
    },
    clickable: {
      cursor: 'pointer',
    },
    applogo: {
      margin: 0,
      padding: 0,
      height: 27,
    },
    appButton: {
      marginTop: 0, // Adjust to align better with text
      paddingTop: 2,
      paddingBottom: 2,
      paddingRight: 16,
      paddingLeft: 16
    },
    applabellogo: {
      margin: 0,
      padding: 0,
      height: 27,
    },
    downloadButton: {
      marginTop: 0 // Adjust to align better with text
      // marginLeft: theme.spacing(1),
      // marginTop: '20px',
      // marginBottom: theme.spacing(1),
    },
    dateField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 4,
      width: 180,
    },
    textField2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 3,
      width: 160,
    },
    textFieldSearch: {
      marginRight: theme.spacing(1),
      marginTop: 3,
      marginLeft: 0,
      width: 300,
    },
      paper1: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    paper2: {
      padding: 12,
      textAlign: 'left',
      color: theme.palette.text.secondary,
    },
    paper3: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    tblWidth: {
      maxWidth: 340,
    },
    tblCellWidth120: {
      width: 120,
      borderBottom: 0,
      padding: '2px 28px 2px 12px',
    },
    tblCellWidth80: {
        width: 60,
        borderBottom: 0,
        padding: '2px 8px 2px 8px',
    },
    tblCellTt: {
        width: 32,
        borderBottom: 0,
        padding: '2px 8px 2px 8px',
    }
});

class CustomerProjectStatement extends Component {

  constructor(props) {
    super(props);

    this.state = {
      projectId: this.props.projects[0].projectId,
      statementIndex: this.props.initialStatement,
      mountLoadComplete: false,
      startDate: null,
      endDate: null,
      siId: null,
      cAccountId: this.props.cAccountId,
      page: 0,
      rowsPerPage: 10,
      
      showButtonSpinner: false,

      requestCancelDialog: false,
      requestCancelSpinner: false,
    };  
  }

  /*
   * Need a mount time load in order to set the initial state of siId correctly.
   */
  componentDidMount() {
    // If fbClientId is passed in, the customer is linked to a FreshBooks client, so we'll need
    // to check if the current statement hasn't already been associated with a FreshBooks invoice.
    if (this.props.fbClientId != null && this.props.fbClientId !== '') {
      // Get the period from passed props - that's what we'll look for.
      let selectAccountId = this.props.cAccountId;
      let selectedIndex   = this.props.initialStatement;
      let selectedStart   = null;
      let selectedEnd     = null;
  
      let savedStatementSearch = localStorage.getItem('lastStatement');
      if (savedStatementSearch) {
        let search = savedStatementSearch.split("|");
        selectedIndex = search[0];
      }

      // Now lookup the appropriate record to determine if there is an siId.
      let theSiId = null;
      StatementSelectFetch.fetch(selectAccountId, abEnvironment.getUserAttribute('a_id')).toPromise()
      .then(ssf => {
        let nodes = ssf.getstatementperiods2.nodes;
        if (selectedIndex < nodes.length) {
          theSiId       = nodes[selectedIndex].siId;
          selectedStart = nodes[selectedIndex].startTs;
          selectedEnd   = nodes[selectedIndex].endTs;
        }

        this.setState({siId: theSiId, mountLoadComplete: true, startDate: selectedStart, endDate: selectedEnd});
      })
      .catch(err => {
        //nothing to do....
      });
    }

    //fetch account info for the button logic.
    if (this.state.account == null) {
      let acctId = this.props.cAccountId;

      AccountFetch.fetch(acctId).toPromise()
      .then(af => {
        if (af.accountTByAccountId) {

          this.setState({account: af.accountTByAccountId});
        }
      }).catch(err => {
        //don't do anything with bad fetching account
      })
    }
  }
  
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };
  
  setProjectSelectState = (idx) => {
    let projectStorage = idx;
    localStorage.setItem('lastProject', projectStorage);
    this.setState({ projectId: this.props.projects[idx].projectId, page: 0});
  }

  setStatementSelectState = (idx, startTs, endTs, siId) => {
    // Note - don't set statement storage to include the siId - this is account specific
    let statementStorage = idx + '|' + startTs + '|' + endTs;
    localStorage.setItem('lastStatement', statementStorage);
    this.setState({ statementIndex: idx, startDate: startTs, endDate: endTs, siId: siId, page: 0});
  }

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  // The download needs to do another query in case there is more data for
  // the range than is shown on the screen.
  /*
  downloadCsv(startDate, endDate, cAccountId, first, offset) { 
    alert('startDate is ' + startDate);
  }
  */
  downloadCsv(startDate, endDate, cAccountId, projectId, first, offset) { 

    const { logError } = this.props.auth;

    var endDateStr;
    if (endDate == null) {
      endDateStr = format(new Date(), 'yyyy-MM-dd');
    } else {
      endDateStr = format(new Date(endDate), 'yyyy-MM-dd');
    }

    CustomerProjectStatementLinesFetch.fetch(cAccountId, projectId, startDate, endDate, first, offset).toPromise()
    .then(sl => {
      let theCount = sl.getcustomerstatementlinesforproject.totalCount;
      if (theCount < 1) {
        return;
      }
      let thenodes = sl.getcustomerstatementlinesforproject.nodes;
      let csv;

      csv = 'Date,Item,Charge,Fee,Payment,Source,Balance\n';
      thenodes.forEach(n => {
        let tType = n.transactionType;
        let tdate = format(new Date(n.transactionTime), 'yyyy-MM-dd');
        let app = '';
        if (n.appName) {
          app = n.appName;
        }
        let charge = '';
        if (n.bindCardCharge) {
          let bcCharge = n.bindCardCharge * -1;
          charge = Number(bcCharge)
          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
        } 
        
        let markup = '';
        let mup = 0;
        if (n.markup) {
          mup = Number(n.markup);
        }

        if (n.passThroughFee != null) {
          mup = mup + Number(n.passThroughFee);
        }
        if (tType === 8 && n.psCFee != null) {
          mup = mup + Number(n.psCFee);
        }

        if (mup > 0 && tType !== 15) {
          markup = Number(mup * -1)
                .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
        }

        //handle refund
        if (tType === 6) {
          if (mup < 0) {
            markup = Number(mup * -1).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
          }
        }

        //debit account from appbind.
        if (tType === 16) {
          markup = '(' + Number(mup * -1).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2}) + ')';
        }
        
        let payment = '';
        if (n.psOutAmt) {
          payment = Number(n.psOutAmt)
          .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
        }

        //credit account from appbind
        if (tType === 15) {
          payment = Number(mup).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
        }

        let source = '';
        if (n.psType != null) {
          if (n.psCcBrand) {
            source = 'CC ***' + n.psCcLast4;
          } else {
            // psSource = 'ACH ***' + n.psAchAccountNum;
            source = 'ACH';
          }
        }

        let balance = '';
        if (n.balance) {
          balance = Number(n.balance).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
        }

        let csvline = '' + tdate + ',' + app + ',"' + charge + '",'  + markup + ',"' + payment + '",' + source + ',"' + balance + '"\n';
        csv = csv + csvline;
      });

      var downloadName = 'AppBind-Statement-' + endDateStr + '.csv';
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = downloadName;
      hiddenElement.click(); 
    })
    .catch(err => {
      // alert('Error: ' + err);
      logError('Exception in CustomerProjectStatement.js: ' + err);
    });
    
  }

  syncToAccounting() {
    this.setState({ showButtonSpinner: true });
    const { callPartnerApi } = this.props.auth;
    Promise.resolve()
    .then(() => {

      // let aPjwt = abEnvironment.getPjwt();
      let payload = {
        operation: "FreshBooksLinkStatementToInvoice",
        params: {
          abCustomerAccountId: this.state.cAccountId,
          startTs: this.state.startDate,
          endTs: this.state.endDate
        }
      };
  
      return callPartnerApi('appbind/generic', 'POST', payload);
    })
    .then(response => {
      return response.json();
    })
    .then(jresp => {
      /*let sbmesg = '';
      if (jresp.abMessage != null) {
        sbmesg = jresp.abMessage;
      } else {
        sbmesg = 'Initiated';
      }*/
      this.setState({ showButtonSpinner: false });
      window.location.reload();
    })
    .catch(err => {
      /*let sbmesg = '';
      if (err.error != null) {
        sbmesg = 'Error in invoice lookup: ' + err.error;
      } else {
        sbmesg = 'Unidentified error in invoice lookup';
      }*/
      this.setState({ showButtonSpinner: false });
    });
  }

  render() {
    const { isAuthenticatedReseller, isAuthenticatedCustomer, isUnauthenticatedCustomer, isAuthenticatedAppBind, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    if ((!isAuthenticatedCustomer() && !isUnauthenticatedCustomer() && !isAuthenticatedReseller() && !isAuthenticatedAppBind()) || needAssent()) { 
      return ( <Redirect to='/home' /> );
    }    

    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;

    let totalCount = 0;

    let selectAccountId = this.state.cAccountId;

    let selectedIndex = this.state.statementIndex;
    let selectedStart = this.state.startDate;
    let selectedEnd   = this.state.endDate;

    let savedStatementSearch = localStorage.getItem('lastStatement');
    if (savedStatementSearch) {
      let search    = savedStatementSearch.split("|");
      selectedIndex = search[0];
      selectedStart = search[1];
      selectedEnd   = search[2];
    }

    //"Show button" logic for everything.
    let showDownloadButton = true;

    let showFbSyncButton = false;
    let showFbSyncButtonDisabled = false;
    let showFbSyncLabel = false;
    if (this.props.fbClientId != null && this.props.fbClientId !== '') {
      if (this.state.mountLoadComplete === true) {
        // Is this statement the current period, and therefore incomplete and not ready for integration
        if (selectedEnd != null) {
          // Check the current time
          let nowDate = new Date();
          let endDate = new Date(selectedEnd);
          if (nowDate.getTime() > endDate.getTime()) {          
            if (this.state.siId == null) {
              showFbSyncButton = true;
            } else {
              showFbSyncLabel = true;
            }
          } else {
            if (this.state.siId == null) {
              showFbSyncButtonDisabled = true;
            }
          }
        }
      }
    }

    //limit the display of the "terminateAccount" segments depending on role and ID (must be customer and must be operating on own account)
    let showTerminateCustomer = (isAuthenticatedCustomer() || isUnauthenticatedCustomer()) && abEnvironment.getUserAttribute("a_id") === this.props.cAccountId;

    return (
      <div className={classes.root}>
        <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="center">
          {this.props.projects.length > 1 &&
          <Grid item xs={12}>
            <ProjectSelect
              projects={this.props.projects}
              setProjectSelectState={this.setProjectSelectState}
              accountId={selectAccountId}
              projectId={this.state.projectId}
              widthOverride={270}
            />
           </Grid>
          }
          <Grid item>
            <StatementSelect
              setStatementSelectState={this.setStatementSelectState}
              accountId={selectAccountId}
              statementIndex={selectedIndex}
              widthOverride={270}
            />
          </Grid>
          <Grid item>
            <Grid container spacing={2}>
              { showFbSyncButton && ! this.state.showButtonSpinner &&
              <Grid item>
                <Button
                  color="primary"
                  variant="outlined"
                  className={classes.appButton}
                  onClick={() => 
                    this.syncToAccounting()
                  }
                >
                  Create in &nbsp;
                  <img
                    alt="App"
                    src={this.props.fbLogo}
                    className={classes.applogo}
                  />                  
                </Button>
              </Grid>}
              { showFbSyncButton && this.state.showButtonSpinner &&
              <Grid item>
                <Button
                  color="primary"
                  variant="outlined"
                >
                  <SavingSpinner/>
                </Button>
              </Grid>}
              { showFbSyncButtonDisabled  &&
              <Grid item>
                <Tooltip title="You'll be able to create an invoice in FreshBooks for this statement at the end of the period.">
                  <div>
                    <Button
                      color="primary"
                      variant="outlined"
                      disabled={true}
                      className={classes.appButton}
                    >
                      Create in &nbsp;
                      <img
                        alt="App"
                        src={this.props.fbLogo}
                        className={classes.applogo}
                      />                  
                    </Button>
                  </div>
                </Tooltip>
              </Grid>}
              { showFbSyncLabel &&
              <Grid item>
                <Tooltip title='This statement has been sent to FreshBooks'>
                  <Grid container spacing={1} alignItems="center">
                    <Grid item>
                      <Typography color="primary" variant="button">Created in</Typography>
                    </Grid>
                    <Grid item>
                      <img
                        alt="App"
                        src={this.props.fbLogo}
                        className={classes.applabellogo}
                      />
                    </Grid>
                  </Grid>
                </Tooltip>
              </Grid>}


              { showTerminateCustomer && this.state.account != null && this.state.account.accountType === 4 &&
                <Grid item>
                  { !this.state.requestCancelSpinner ?
                    (<Tooltip title={'You can terminate your subscription arrangement and receive a balance refund at any time.'}>
                      <Button color="primary" 
                        variant={'outlined'}
                        disabled={this.state.account.accountStatus === 3}
                        onClick={() => { this.setState({requestCancelDialog: true});}}
                      >
                        Refund balance
                      </Button>
                    </Tooltip>)
                    : 
                    (<Button>
                      <SavingSpinner/>
                    </Button>)
                  }

                  <RefundAndTerminateDialog account={this.state.account} auth={this.props.auth}
                    setSaveSpinner={ (value) => { this.setState( { requestCancelSpinner: value }) }}
                    open={this.state.requestCancelDialog}
                    onClose={() => { this.setState({ requestCancelDialog: false }); }}
                    onCancel={() => { this.setState({ requestCancelDialog: false }); }}
                  />
                </Grid>
              }

              { showDownloadButton &&
              <Grid item>
                <Button
                  color="primary"
                  variant="outlined"
                  className={classes.downloadButton}
                  onClick={() => 
                    this.downloadCsv(selectedStart, selectedEnd, this.state.cAccountId, this.state.projectId, 10000, 0)
                  }
                >
                  Download Statement&nbsp;&nbsp;<GetApp/>
                </Button>
              </Grid>}
            </Grid>
          </Grid>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={CustomerProjectStatementQuery}
            variables={{cAccountId: this.state.cAccountId,
                        projectId: this.state.projectId,
                        startDate: selectedStart,
                        endDate: selectedEnd,
                        first: first,
                        offset: offset}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                // Determine offset information
                totalCount = props.getcustomerstatementlinesforproject.totalCount;

                // let accountStatus = props.accountTByAccountId?.accountStatus;
                // let account = props.accountTByAccountId;

                let beginningBalance = 0;
                let paymentIn = 0;
                let receivedIn = 0;
                let chargeOut = 0;
                let endingBalance = 0;
                if (totalCount > 0) {
                  let firstNode = props.getcustomerstatementlinesforproject.nodes[0];

                  if (firstNode.beginningBalance)
                    beginningBalance = firstNode.beginningBalance;
                  if (firstNode.paymentIn)
                    paymentIn = firstNode.paymentIn;
                  if (firstNode.receivedIn)
                    receivedIn = firstNode.receivedIn;
                  if (firstNode.chargeOut)
                    chargeOut = firstNode.chargeOut;
                  //if (firstNode.payoutOut)
                  //  payoutOut = firstNode.payoutOut;
                  if (firstNode.endingBalance)
                    endingBalance = firstNode.endingBalance;
                }
                let beginningBalanceF = Number(beginningBalance).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                let paymentInF        = Number(paymentIn).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                let receivedInF       = Number(receivedIn).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                let chargeOutF        = Number(chargeOut).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                //let payoutOutF        = Number(payoutOut).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
                let endingBalanceF    = Number(endingBalance).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

                return (
                  <Grid item xs={12}>
                    <Grid container spacing={1} direction="row" justifyContent="flex-start">
                      <Grid item xs={12}>
                        <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                          Statement summary
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Table className={classes.tblWidth}>
                          <TableBody>
                            <TableRow>
                              <TableCell className={classes.tblCellWidth120}><Typography variant="body1">Beginning balance</Typography></TableCell>
                              <TableCell align="right" className={classes.tblCellWidth80}><Typography variant="body1">{beginningBalanceF}</Typography></TableCell>
                              <TableCell className={classes.tblCellTt}>
                                <Tooltip placement='right' title='Your AppBind balance is the amount available to purchase subscriptions. This is your balance at the beginning of the statement period.'>
                                  <HelpOutline fontSize="small" style={{verticalAlign: "-8%"}}/>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classes.tblCellWidth120}><Typography variant="body1">Payments</Typography></TableCell>
                              <TableCell align="right" className={classes.tblCellWidth80}><Typography variant="body1">{paymentInF}</Typography></TableCell>
                              <TableCell className={classes.tblCellTt}>
                                <Tooltip placement='right' title='This is the amount of payments that you have made to apply to subscriptions and fees.'>
                                  <HelpOutline fontSize="small" style={{verticalAlign: "-8%"}}/>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classes.tblCellWidth120}><Typography variant="body1">Received</Typography></TableCell>
                              <TableCell align="right" className={classes.tblCellWidth80}><Typography variant="body1">{receivedInF}</Typography></TableCell>
                              <TableCell className={classes.tblCellTt}>
                                <Tooltip placement='right' title='This is the amount of subscription charge refunds you received.'>
                                  <HelpOutline fontSize="small" style={{verticalAlign: "-8%"}}/>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classes.tblCellWidth120}><Typography variant="body1">Charges</Typography></TableCell>
                              <TableCell align="right" className={classes.tblCellWidth80}><Typography variant="body1">{chargeOutF}</Typography></TableCell>
                              <TableCell className={classes.tblCellTt}>
                                <Tooltip placement='right' title='This is the amount you have paid for subscriptions and fees.'>
                                  <HelpOutline fontSize="small" style={{verticalAlign: "-8%"}}/>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell className={classes.tblCellWidth120}><Typography variant="body1">Ending balance</Typography></TableCell>
                              <TableCell align="right" className={classes.tblCellWidth80}><Typography variant="body1">{endingBalanceF}</Typography></TableCell>
                              <TableCell className={classes.tblCellTt}>
                                <Tooltip placement='right' title='This is your balance at the at the end of the statement period.'>
                                  <HelpOutline fontSize="small" style={{verticalAlign: "-8%"}}/>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                          Transactions
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <CustomerProjectStatementLines cl={props.getcustomerstatementlinesforproject} history={this.props.history}/>
                      </Grid>
                      <Grid item xs={12}>
                        <TablePagination
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          component="div"
                          count={totalCount}
                          rowsPerPage={this.state.rowsPerPage}
                          page={this.state.page}
                          backIconButtonProps={{
                            'aria-label': 'Previous Page',
                          }}
                          nextIconButtonProps={{
                            'aria-label': 'Next Page',
                          }}
                          onPageChange={this.handleChangePage}
                          onRowsPerPageChange={this.handleChangeRowsPerPage}
                          />                        
                      </Grid>
                    </Grid>
                  </Grid>
                )
              }
              return (
                <LoadingSpinner />
              );
            }}
          />
        </Grid>
      </div>
    );
  }
}
  
CustomerProjectStatement.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(CustomerProjectStatement);
